import {
  getNewStore,
  getMainStoreInstance,
  getMainHelper,
  getIndex,
  widgets,
  isAISReset,
  isAISRun,
  setAISRun,
  setAISSleep,
  mainPanelId,
  mainHitsId,
  mainStoreName,
} from '../../common/Algolia';
import {
  isEmpty,
  stripHTML,
  removeDuplicates,
} from '../../common/Utils';
import {
  triggerAlgoliaProductThumbnailClickedEvent,
} from '../../common/Events';
import {
  getItemBrand,
  getItemCategory,
  getItemVariant,
  getItemClass,
  getItemListName,
} from '../../common/organism/product-thumbnails-module';
import GlobalVars from '../../common/GlobalVars';
import * as header from '../../common/organism/header';
import { checkStock } from '../../common/organism/out-of-stock';
import { closeAddToBagPopin } from '../../common/organism/popin.addtobag';

const isLandingSearch = GlobalVars.isSearchPage;

const dicoValueKey = 'value';
const dicoAddToBagKey = 'add_to_bag';
const dicoOutOfStockKey = 'no_stock';
const dicoReviewNoteKey = 'review_note';
const dicoViewAllKey = 'viewAll';
const dicoShowMoreKey = 'showMore';
const dicoNoResultTitleKey = 'no_result_title';
const dicoNoResultSubTitleKey = 'no_result_subtitle';
const dicoNoResultTipLinksKey = 'no_result_links';
const dicoNoResultSpecificSkusKey = 'no_result_skus';
const dicoNoResponseTitleKey = 'no_response_title';
const dicoNoResponseSubTitleKey = 'no_response_subtitle';
const dicoNoResultBestSellersSelectionKey = 'no_result_titleBestSellersSelection';
const dicoShowMoreBestSellersLinkKey = 'no_result_ShowMoreLink';

// Constants (ids)
const searchFieldId = 'searchField';

// Constants (classes)
const panelOpenClass = 'ais-open';
const showMoreClass = 'ais-infinite-hits--showmore';
const itemClass = 'o-product-thumbnails-module__item';
const itemListClass = `${itemClass}--list`;
const blockClass = 'o-product-thumbnails-module__block';
const blockOOSClass = 'o-product-thumbnails-block--oos';
const btnClass = 'o-product-thumbnails-block__btn';
const btnDisableClass = 'a-btn--secondary-1';
const loaderContainer = 'ais-search-box--loading-indicator-wrapper';
const loaderIndicator = 'ais-search-box--loading-indicator';
const accountHeaderClass = 'o-account-header-customer';
const moduleClass = 'ais-module';
const storeOptions = {
  indexName: '',
  searchParameters: {
    hitsPerPage: 6,
  },
};

// Constants (attributes)
const dataNameAttr = 'data-name';
const dataPriceAttr = 'data-price';
const dataSkuAttr = 'data-ocms-thumb-sku';

let $closest;
let pushEvent = false;

/* Get store instance */
let occStore;
let helper;

/* Dico related props */
let dicoAddToBag;
let dicoValue;
let dicoOutOfStock;
let dicoReviewNote;
let dicoViewAll;
let dicoShowMore;
let dicoShowMoreBestSellersLink;
let dicoNoResultTitle;
let dicoNoResultSubTitle;
let dicoNoResultTipLinks;
let dicoNoResultSpecificSkus;
let dicoNoResultBestSellersSelection;
let dicoNoResponseTitle;
let dicoNoResponseSubTitle;

/* Element waiting for templates rendering (render event) */
let $aisShowMore;
let $aisShowMoreBtn;
let $aisResultPanel;

let noResultSearch = {};
let bestSellers = [];
let noResultBestSellers = [];
let listOfNoResultLinks = [];
let stringListOfSku;
let arrayListOfSku = [];
let searchKeyword = '';

/* DOM elements use as starting points */
let $hitsArea;

let paginationSentry = false;
let isEmptyResponse = false;

// SPE Azure
function transformImageUrl(url) {
  const siteUrl = window.location.origin;
  const regexUrlProd = /\/.{2,3}-prod\./;
  const regexUrlPreProd = /\/.{2,3}-pp\./;

  if (regexUrlProd.test(siteUrl) === true) {
    return url.replace(/\/img\./, '/img-prod.');
  }
  if (regexUrlPreProd.test(siteUrl) === true) {
    return url.replace(/\/img\./, '/img-pp.');
  }
  return url;
}

function getResultPanel() {
  return $(`#${mainPanelId}`);
}

function setStockState(skuStates) {
  if (typeof skuStates !== 'undefined') {
    /* Keeping only the outOfStock ones */
    const oosList = skuStates.filter((elem) => {
      if (elem.InStock === false) {
        return elem.SKU;
      }
      return false;
    });

    /* Apply DOM update on them */
    oosList.forEach((elem) => {
      $(`.${itemListClass}[data-ocms-thumb-sku=${elem.SKU}] .${blockClass}`)
        .addClass(blockOOSClass)
        .find(`.${btnClass}`)
        .addClass(btnDisableClass)
        .text(dicoOutOfStock);
    });
  }
}

function isLastPage(pageIndex) {
  return (pageIndex === (helper.lastResults.nbPages - 1));
}

function requestStockState(rawList) {
  if (rawList.length > 0) {
    /* Map an array with the current displayed hits skus */
    const mapList = rawList.map(items => items.sku);
    /* Call XCMS services to get stock informations */
    checkStock(mapList, setStockState);
  }
}

function setupShowMore() {
  $aisShowMore = $(`.${showMoreClass}`);
  $aisShowMoreBtn = $aisShowMore.find('button');

  /* Prevent focus and main form submition (page structure) */
  $aisShowMoreBtn.attr({
    type: 'button',
  });

  $hitsArea[0].addEventListener('click', (event) => {
    if ($(event.target).is($aisShowMoreBtn)) {
      event.stopImmediatePropagation();

      if (!isEmptyResponse && $aisResultPanel.hasClass(panelOpenClass) && !isLastPage(helper.state.page)) {
        helper.state.hitsPerPage = helper.lastResults.nbHits; // Set state to the last page before triggerring 'SHOW MORE'
        paginationSentry = true;
        helper.search();
      }
    }
  }, true);
}

function buildBadges(badgeList) {
  const badgeTplList = [];

  badgeList.forEach((elem) => {
    if (elem.url.trim() !== '') {
      badgeTplList.push(
        `<li class="m-product-badge__item">
          <img class="a-img a-img--product-badge" src="${transformImageUrl(elem.url)}" alt="${elem.title}">
        </li>`
      );
    }
  });

  return `<ul class="o-product-thumbnails-block__badge-list m-product-badge">
            ${(badgeTplList.length > 0) ? badgeTplList.join('') : ''}
          </ul>`;
}

function buildLabels(labelList) {
  const labelTplList = [];
  labelList.forEach((elem) => {
    if (elem.trim() !== '') {
      labelTplList.push(
        `<li class="m-product-label__item">
          <span class="m-product-label__text a-text-xs">${elem}</span>
        </li>`
      );
    }
  });

  return `<ul class="o-product-thumbnails-block__label-list m-product-label">
            ${(labelTplList.length > 0) ? labelTplList.join('') : ''}
          </ul>`;
}

function buildPrice(data) {
  let valuePriceTpl = '';
  let beforePriceTpl = '';
  let priceTpl = `<span class="o-product-thumbnails-block__price a-text-secondary-m a-text-secondary-m--xbold" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
                    <meta itemprop="priceCurrency" content="${GlobalVars.CurrencyCode}" />
                    <span itemprop="price" content="${data.price_f}">${data.price}</span>
                  </span>`;

  if (data.value_price || data.price_before) {
    if (data.value_price) {
      valuePriceTpl = `<span class="o-product-thumbnails-block__old-price">
                         <span class="o-product-thumbnails-block__old-price-label a-text-secondary-s a-text-secondary-s--secondary-color">${dicoValue}</span>
                         <span class="a-text-secondary-s a-text-secondary-s--secondary-color">${data.value_price}</span>
                       </span>`;

      priceTpl += valuePriceTpl;
    } else {
      beforePriceTpl = `<span class="o-product-thumbnails-block__old-price">
                          <s class="a-text-secondary-s a-text-secondary-s--former">${data.price_before}</s>
                        </span>`;

      priceTpl += beforePriceTpl;
    }
  }

  return priceTpl;
}

function buildReviews(data) {
  const rate = data.reviews_note;

  const reviewNoteTpl = `<div class="star-rating m-rating o-product-thumbnails-block__rating-img">
                           <span style="width:${(rate * 100) / 10}%;"></span>
                         </div>`;

  const reviewCountTpl = `<span class="o-product-thumbnails-block__label a-rate-label">
                            <span itemprop="reviewCount">(${data.reviews_count})</span>
                          </span>`;

  const reviewContainer = `<div class="o-product-thumbnails-block__rating" itemprop="aggregateRating" itemscope itemtype="http://schema.org/AggregateRating">
                             ${reviewNoteTpl}
                             <span class="sr-only">
                               ${dicoReviewNote}
                               <span itemprop="worstRating">1</span>
                               <span itemprop="ratingValue">${rate}</span>
                               <span itemprop="bestRating">10</span>
                             </span>
                             ${reviewCountTpl}
                           </div>`;

  return reviewContainer;
}

function formatListOfNoResultLinks() {
  listOfNoResultLinks = [];
  const stringListLink = stripHTML(`${dicoNoResultTipLinks}`);
  const arrayListLink = stringListLink.split(';');
  for (let i = 0, len = arrayListLink.length; i < len; i += 2) {
    listOfNoResultLinks.push({ label: arrayListLink[i], link: arrayListLink[i + 1] });
  }
}

function displayListOfNoResultLinks() {
  formatListOfNoResultLinks();
  if (listOfNoResultLinks[0].label !== '') {
    for (let i = 0; i < listOfNoResultLinks.length; i += 1) {
      const listItem = `<li class='o-no-result-internal-search__links-item-container'><a class='a-text-m a-text-m--link' href=${listOfNoResultLinks[i].link}>${listOfNoResultLinks[i].label}</a><span class="o-no-result-internal-search__links-separator">, </span></li>`;
      $('.o-no-result-internal-search__links').append(listItem);
    }
  } else {
    $('.o-no-result-internal-search__subtitle').first().remove();
    $('.o-no-result-internal-search__links').remove();
  }
}

function formatNoResultsSpecificSkus() {
  arrayListOfSku = [];
  stringListOfSku = stripHTML(`${dicoNoResultSpecificSkus}`);
  arrayListOfSku = removeDuplicates(stringListOfSku.split(';'));
}

function displayNoResultsSpecificSkus() {
  storeOptions.indexName = getIndex(mainStoreName, 'bestseller').index;
  noResultSearch = getNewStore(storeOptions);

  noResultSearch.searchParameters.disjunctiveFacetsRefinements = {
    sku: arrayListOfSku
  };

  noResultSearch.start();
}

function displayNoResultBestSellers() {
  storeOptions.indexName = getIndex(mainStoreName, 'bestseller').index;
  noResultSearch = getNewStore(storeOptions);
  noResultSearch.searchParameters.disjunctiveFacetsRefinements = {};
  noResultSearch.start();
}

/* Only use in Algolia Hits sorting (need sku property) */
function hitsBySkuIndex(aHit, bHit) {
  return arrayListOfSku.indexOf(aHit.sku) - arrayListOfSku.indexOf(bHit.sku);
}

function buildThumbmails() {
  let badgeTplNoresult = '';
  let labelContainerTplNoresult = '';
  let sizeTplNoresult = '';
  let priceTplNoresult = '';
  let reviewTplNoresult = '';
  bestSellers = [];

  $('.o-no-result-internal-search__bestsellers-container').empty();

  if ($.isEmptyObject(noResultSearch) === true) {
    if (stringListOfSku !== '') {
      displayNoResultsSpecificSkus();
    } else {
      displayNoResultBestSellers();
    }

    noResultSearch.helper.on('result', (results) => {
      noResultBestSellers = [];
      bestSellers = (results.hits.length !== 0) ? results.hits.sort(hitsBySkuIndex) : results.hits;

      for (let i = 0, len = bestSellers.length; i < len; i += 1) {
        /* Build badges HTML list */
        if (bestSellers[i].badges && bestSellers[i].badges.length > 0) {
          badgeTplNoresult = buildBadges(bestSellers[i].badges);
        } else {
          badgeTplNoresult = '';
        }

        /* Build labels HTMl list */
        if (bestSellers[i].labels && bestSellers[i].labels.length > 0) {
          labelContainerTplNoresult = buildLabels(bestSellers[i].labels);
        } else {
          labelContainerTplNoresult = '';
        }

        if (bestSellers[i].size) {
          sizeTplNoresult = `<div class="a-text-s a-text-s--secondary-color">${bestSellers[i].size}</div>`;
        } else {
          sizeTplNoresult = '';
        }

        /* Build price */
        if (bestSellers[i].price) {
          priceTplNoresult = buildPrice(bestSellers[i]);
        } else {
          priceTplNoresult = '';
        }

        /* Build reviews */
        if (bestSellers[i].reviews_note) {
          reviewTplNoresult = buildReviews(bestSellers[i]);
        } else {
          reviewTplNoresult = '';
        }

        const ctaTplNoresult = `<span class="${btnClass} a-btn">${dicoAddToBag}</span>`;

        noResultBestSellers.push(`<div class="ais-infinite-hits--item ${itemClass}">
          <li class="${itemListClass} o-no-result-internal-search__item" data-ocms-thumb-sku="${bestSellers[i].sku || ''}" data-ais-id="${bestSellers[i].id || ''}" data-stock="${bestSellers[i].stock || ''}" data-brand="${bestSellers[i].collections || ''}" data-category="${bestSellers[i].section || ''}" data-variant="${bestSellers[i].size || ''}" data-class="${'NORMAL' || ''}" data-list="InternalSearchList" data-name="${bestSellers[i].title || ''}" data-price="${stripHTML(bestSellers[i].price) || ''}">
            <div class="o-product-thumbnails-module__block o-product-thumbnails-block" itemscope itemtype="http://schema.org/Product">
              <div class="o-product-thumbnails-block__top">
                <img itemprop="image" class="a-img a-img--medium" src="${transformImageUrl(bestSellers[i].image_url) || ''}" alt="${bestSellers[i].image_alt || ''}">
                ${badgeTplNoresult}
                ${labelContainerTplNoresult}
              </div>
              <div class="o-product-thumbnails-block__middle">
                <div class="o-product-thumbnails-block__title-volume">
                  <div class="o-product-thumbnails-block__title a-text-m">
                    <a itemprop="url" class="o-product-thumbnails-block__link" href="${bestSellers[i].url || ''}">
                      <span itemprop="name">${bestSellers[i].title || ''}</span>
                    </a>
                  </div>
                  ${sizeTplNoresult}
                </div>
                ${reviewTplNoresult}
              </div>
              <div class="o-product-thumbnails-block__bottom">
                ${priceTplNoresult}
                ${ctaTplNoresult}
              </div>
            </div>
          </li></div>`);
      }
      for (let i = 0, len = noResultBestSellers.length; i < len; i += 1) {
        $('.o-no-result-internal-search__bestsellers-container').append(noResultBestSellers[i]);
      }
    });
  } else {
    noResultSearch.helper.search();
  }
}

function hideLoader() {
  $(`.${loaderIndicator}, .${loaderContainer}`).hide();
}

function getItemPosition(aoItem) {
  const $item = $(aoItem);
  let position = 0;

  if ($item.length) {
    $(`.${moduleClass} [${dataSkuAttr}]`).each((anIndex, aoElement) => {
      if ($(aoElement).is($item)) {
        position = anIndex + 1;

        return false; // break
      }

      return true; // continue
    });
  }

  return position;
}

function getData($item) {
  return {
    position: getItemPosition($item),
    category: getItemCategory($item),
    price: $item.attr(dataPriceAttr),
    brand: getItemBrand($item),
    name: $item.attr(dataNameAttr),
    variant: getItemVariant($item),
    productClass: getItemClass($item),
    list: getItemListName($item),
  };
}

// triggerAlgoliaProductThumbnailClickedEvent when user clicks on a product thumbnail from an instant search product list panel
function handleAlgoliaProductThumbnailLinkClick($target) {
  const $item = $target;

  if ($item.length) {
    const sku = $item.attr(dataSkuAttr);

    if (isEmpty(sku) === false) {
      let dataProduct = getData($item);
      dataProduct.id = sku;
      // Strip all HTML in one hit
      dataProduct = JSON.parse(stripHTML(JSON.stringify(dataProduct)));

      if (isLandingSearch) {
        searchKeyword = $(`#${searchFieldId}`).val();
      }

      triggerAlgoliaProductThumbnailClickedEvent(dataProduct, searchKeyword);
    }
  }
}

function handleShowMoreDisplay() {
  if (isEmptyResponse || $aisShowMore.find('button[disabled]').length > 0) {
    $aisShowMore.removeClass(panelOpenClass);
  } else {
    $aisShowMore.addClass(panelOpenClass);
  }
}

/* Register events once after the rendering complete */
function hitsEventSetup() {
  if (typeof occStore !== 'undefined') {
    occStore.once('render', () => {
      helper = getMainHelper();

      /* Fix default button setup */
      setupShowMore();

      handleShowMoreDisplay(); // Handle btn on first start (no available helper)

      if (isLandingSearch) {
        /* Formating data before sending request */
        setTimeout(() => {
          requestStockState(helper.lastResults.hits.slice(0, helper.lastResults.hitsPerPage));
        }, 0);
      }

      /* Local handler on global "result" event */
      helper.on('result', (results) => {
        searchKeyword = results.query;

        handleShowMoreDisplay(); // Handle btn on other queries (helper available)

        if (paginationSentry === true) {
          paginationSentry = false;
        }

        if (isAISRun(mainStoreName)) {
          /* Formating data before sending request */
          setTimeout(() => {
            requestStockState(results.hits);
          }, 0);
        }
      });

      /* TEMP use in library fix for duplicate hits problem in showMore */
      helper.on('change', () => {
        if (!paginationSentry) {
          helper.state.hitsPerPage = 18; // Reset hitsPerPage if not showMoreRelated 'change'
        }
      });
    });

    occStore.on('render', () => {
      /* Prevent display in other state */
      if (isAISRun(mainStoreName)) {
        /* Handle panel first opening */
        if (!$aisResultPanel.hasClass(panelOpenClass)) {
          /* Get main-nav height before hidding */
          const $nav = $(`#${header.navId}`);
          const $accountHeader = $(`.${accountHeaderClass}`);
          const initialNavHeight = $nav.height();

          /* Adjust site initial padding */
          $(`#${header.siteId}`).css('margin-top', -initialNavHeight);

          /* Hide main nav */
          $nav.attr({
            style: 'visibility: hidden; height: 15px',
            'aria-hidden': true,
          });

          /* Hide account header */
          if ($accountHeader.length > 0) {
            $accountHeader.attr({
              style: 'display: none;',
              'aria-hidden': true,
            });
          }

          /* Hide addToBag popin (e.g. product page) */
          closeAddToBagPopin();

          /* Hide overlay and loader */
          if (typeof OCMS.Popin !== 'undefined' && OCMS.Popin.isOpened === true && OCMS.Popin.current.options.id === 'loadingPopin') {
            if (typeof hideLoading === 'function') { hideLoading(false); } // eslint-disable-line no-undef
          }

          /* Display result panel */
          $aisResultPanel
            .addClass(panelOpenClass)
            .attr('aria-hidden', false)
            .siblings('[class*="banner"], #content')
            .css('display', 'none');

          /* Smooth scroll top */
          $('html, body').animate({ scrollTop: 0 }, 500, () => {
            /* Update state */
            setAISRun(mainStoreName);
          });
        }
      } else if (isAISReset(mainStoreName)) {
        setAISSleep(mainStoreName);
      } else {
        setAISRun(mainStoreName);
      }

      // Hide the left side of the result panel
      if ($('.o-no-result-internal-search').length) {
        $('.t-internal-search__column-left').hide();
        displayListOfNoResultLinks();
        formatNoResultsSpecificSkus();
        buildThumbmails();
      } else {
        $('.t-internal-search__column-left').show();
      }
    });

    occStore.on('error', (error) => {
      console.error('===== Algolia ERROR =====.', error);
      hideLoader();
      $('.o-top-internal-search__top').hide();
      $('.t-internal-search__column-left').hide();
      const noResponseTemplate = `<div class='o-no-result-internal-search'>
                                    <h1 class='info a-title-l o-no-result-internal-search__title'>${dicoNoResponseTitle}</h1>
                                    <p class='a-text-m a-text-m--bold o-no-result-internal-search__subtitle'>${dicoNoResponseSubTitle}</p>
                                  </div>`;

      $hitsArea[0].innerHTML = noResponseTemplate;
    });
  } else {
    console.error('Missing Algolia store connection.');
  }
}

/* Searchbox wideget setup */
function hitsInit() {
  /* Init elements */
  $hitsArea = $(`#${mainHitsId}`);
  $aisResultPanel = $(`#${mainPanelId}`);

  if ($hitsArea.length > 0) {
    /* Get Store instance */
    occStore = getMainStoreInstance();

    try {
      dicoAddToBag = OCMS.aisPanel.dicoKeys[dicoAddToBagKey];
      dicoValue = OCMS.aisPanel.dicoKeys[dicoValueKey];
      dicoOutOfStock = OCMS.aisPanel.dicoKeys[dicoOutOfStockKey];
      dicoReviewNote = OCMS.aisPanel.dicoKeys[dicoReviewNoteKey];
      dicoViewAll = OCMS.aisPanel.dicoKeys[dicoViewAllKey];
      dicoShowMore = OCMS.aisPanel.dicoKeys[dicoShowMoreKey];
      dicoNoResultTitle = OCMS.aisPanel.dicoKeys[dicoNoResultTitleKey];
      dicoNoResultSubTitle = OCMS.aisPanel.dicoKeys[dicoNoResultSubTitleKey];
      dicoNoResultTipLinks = OCMS.aisPanel.dicoKeys[dicoNoResultTipLinksKey];
      dicoNoResultSpecificSkus = OCMS.aisPanel.dicoKeys[dicoNoResultSpecificSkusKey];
      dicoNoResultBestSellersSelection = OCMS.aisPanel.dicoKeys[dicoNoResultBestSellersSelectionKey];
      dicoShowMoreBestSellersLink = OCMS.aisPanel.dicoKeys[dicoShowMoreBestSellersLinkKey];
      dicoNoResponseTitle = OCMS.aisPanel.dicoKeys[dicoNoResponseTitleKey];
      dicoNoResponseSubTitle = OCMS.aisPanel.dicoKeys[dicoNoResponseSubTitleKey];
    } catch (error) {
      console.error('===== Missing dicoKeys for AIS-HITS =====', error);
    }

    occStore.addWidget(
      widgets.infiniteHits({
        container: $hitsArea[0], // Expect a vanilla DOM object
        showMoreLabel: dicoViewAll,
        cssClasses: {
          root: 'ais-module o-product-thumbnails-module--product-list',
          empty: '',
          item: `${itemClass}`,
          showmore: `o-product-thumbnails-module__bottom-btn a-btn ${btnDisableClass}`,
        },
        templates: {
          empty: (data) => {
            isEmptyResponse = true;

            $('.o-top-internal-search__top').hide();
            const noResultTop = `<div class='o-no-result-internal-search'>
              <h1 class='info a-title-l o-no-result-internal-search__title'>${dicoNoResultTitle} <span class="a-title-l a-title-l--bold o-no-result-internal-search__search-wording">${data.query}</span></h1>
              <p class='a-text-m a-text-m--bold o-no-result-internal-search__subtitle'>${dicoNoResultSubTitle}</p>
              <ul class='o-no-result-internal-search__links'></ul>
              <div><p class='a-text-m a-text-m--bold o-no-result-internal-search__subtitle'>${dicoNoResultBestSellersSelection}</p></div>
              <ul class="o-no-result-internal-search__bestsellers-container"></ul>
              <a class="o-product-thumbnails-module__bottom-btn o-no-result-internal-search__bottom-btn a-btn a-btn--secondary-1 js-show-more-best-sellers" href="${dicoShowMoreBestSellersLink}">${dicoShowMore}</a>
              </div>`;
            return noResultTop;
          },
          item: (data) => {
            if (isEmptyResponse) {
              isEmptyResponse = false;
            }

            $('.o-top-internal-search__top').show();
            let badgeTpl = '';
            let labelContainerTpl = '';
            let sizeTpl = '';
            let priceTpl = '';
            let reviewTpl = '';

            /* Build badges HTML list */
            if (data.badges && data.badges.length > 0) {
              badgeTpl = buildBadges(data.badges);
            }

            /* Build labels HTMl list */
            if (data.labels && data.labels.length > 0) {
              labelContainerTpl = buildLabels(data.labels);
            }

            if (data.size) {
              sizeTpl = `<div class="a-text-s a-text-s--secondary-color">${data.size}</div>`;
            }

            /* Build price */
            if (data.price) {
              priceTpl = buildPrice(data);
            }

            /* Build reviews */
            if (data.reviews_note) {
              reviewTpl = buildReviews(data);
            }

            /* Format relative url (To remove before release) */
            const fullUrl = data.url;
            const reg = /^http|s:\/\/[\w.]+/g;
            const relativeUrl = fullUrl.replace(reg.exec(fullUrl), '');

            const ctaTpl = `<span class="${btnClass} a-btn">${dicoAddToBag}</span>`;
            /* eslint-disable no-underscore-dangle */
            const hitsTpl = `<li class="${itemListClass}" data-ocms-thumb-sku="${data.sku || ''}" data-ais-id="${data.id || ''}" data-stock="${data.stock || ''}" data-brand="${data.collections || ''}" data-category="${data.section || ''}" data-variant="${data.size || ''}" data-class="${'NORMAL' || ''}" data-list="InternalSearchList" data-name="${data.title || ''}" data-price="${stripHTML(data.price) || ''}">
                              <div class="o-product-thumbnails-module__block o-product-thumbnails-block" itemscope itemtype="http://schema.org/Product">
                                <div class="o-product-thumbnails-block__top">
                                  <img itemprop="image" class="a-img a-img--medium" src="${transformImageUrl(data.image_url) || ''}" alt="${data.image_alt || ''}">
                                  ${badgeTpl}
                                  ${labelContainerTpl}
                                </div>
                                <div class="o-product-thumbnails-block__middle">
                                  <div class="o-product-thumbnails-block__title-volume">
                                    <div class="o-product-thumbnails-block__title a-text-m">
                                      <a itemprop="url" class="o-product-thumbnails-block__link" href="${relativeUrl || ''}">
                                        <span itemprop="name">${data._highlightResult.title.value || ''}</span>
                                      </a>
                                    </div>
                                    ${sizeTpl}
                                  </div>
                                  ${reviewTpl}
                                </div>
                                <div class="o-product-thumbnails-block__bottom">
                                  ${priceTpl}
                                  ${ctaTpl}
                                </div>
                              </div>
                            </li>`;
            /* eslint-enable no-underscore-dangle */
            return hitsTpl;
          },
        },
      })
    );

    /* Setup widget events after once the "render" competion */
    hitsEventSetup();

    $hitsArea[0].addEventListener('click', (event) => {
      const $target = $(event.target);
      $closest = $target.closest(`.${itemListClass}`);

      if ($closest.length) {
        pushEvent = true;
      }
    }, true);

    window.addEventListener('beforeunload', () => {
      if (pushEvent) {
        handleAlgoliaProductThumbnailLinkClick($closest);
      }
    });

    return true;
  }

  return false;
}

// Named exports
export {
  hitsInit,
  getResultPanel,
};



// WEBPACK FOOTER //
// ./js/desktop/molecule/algolia-hits.js